export var mapGetFoldersForOfferResponse = function mapGetFoldersForOfferResponse(response) {
  var folders = response.folders,
    page = response.page;
  var selectedFolders = {};
  folders.forEach(function (folder) {
    if (folder.selected) {
      selectedFolders[folder.id] = true;
    }
  });
  return {
    folders: folders.map(function (folder) {
      return {
        id: folder.id,
        imageUrl: folder.imageUrl || '',
        name: folder.name,
        offersCount: folder.offersCount
      };
    }),
    selectedFolders: selectedFolders,
    canLoadMore: page.canLoadMore
  };
};